import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '~Layout';
import DischargeForecast from './DischargeForecast';
import Due from './Due';
import ExpiringInsurance from './ExpiringInsurance';
import List from './List';
import Loan from './Loan';
import MaturationReminders from './MaturationReminders';
import Drawdowns from '~/LoanDrawdowns/Drawdowns';
import Dashboard from './Dashboard';
import LegacyDashboard from './LegacyDashboard';
import PendingDrawdowns from '~/LoanDrawdowns/PendingDrawdowns';
import OtherRetainedFunds from './OtherRetainedFunds';
import IAuthUser from '~Auth/IAuthUser';
import { useSelector } from 'react-redux';
import { authCurrentUserSelector } from '~Auth/selectors';
import PermissionsEnum from '~Api/Administrator/PermissionsEnum';
import LoanPaymentAbas from '~LoanPaymentAbas';
import LoanDrawdowns from '~LoanDrawdowns';

export default function Router(): ReactElement {
    const currentUser: IAuthUser = useSelector(authCurrentUserSelector);

    return (
        <Layout topSection='loans'>
            <Switch>
                <Route exact={true} path='/loans' component={Dashboard} />
                <Route exact={true} path='/loans/classic' component={LegacyDashboard} />
                <Route exact={true} path='/loans/discharge-forecast' component={DischargeForecast} />
                <Route exact={true} path='/loans/drawdowns' component={Drawdowns} />
                <Route exact={true} path='/loans/due' component={Due} />
                <Route exact={true} path='/loans/expiring-insurance' component={ExpiringInsurance} />
                <Route exact={true} path='/loans/list' component={List} />
                <Route exact={true} path='/loans/maturation-reminders' component={MaturationReminders} />
                {currentUser.permissions.includes(PermissionsEnum.Accounts) && <Route exact={true} path='/loans/other-retained-funds' component={OtherRetainedFunds} />}
                <Route exact={true} path='/loans/pending-drawdowns' component={PendingDrawdowns} />
                {currentUser.permissions.includes(PermissionsEnum.Accounts) && <Route path='/loans/payment-abas' component={LoanPaymentAbas} />}
                <Route path='/loans/:loanUuid/drawdowns' component={LoanDrawdowns} />
                <Route path='/loans/:uuid' component={Loan} />
            </Switch>
        </Layout>
    );
}
